import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import { push } from 'utils/helpers/router'
import { toastSuccess } from 'utils/toast'

import { AddAdsApprovalReqBodyInterface } from 'features/AdsManagement/@types/apiTypes'
import { AdsPrincipalDetailRoute } from 'features/AdsManagement/router/router'
import {
  getPrincipalListAPI,
  postAdsSubmissionsAPI,
} from 'features/AdsManagement/services/principalList'

import { setIsLoading, setPrincipalList, SLICE_NAME } from './slice'

export const fetchPrincipalListForTopUp = createAsyncThunk(
  `${SLICE_NAME}/fetchPrincipalListForTopUp`,
  async (name: string, { rejectWithValue, dispatch }) => {
    dispatch(setIsLoading(true))
    try {
      const response = await getPrincipalListAPI({ seller_name: name, page_size: 10 })

      dispatch(setPrincipalList(response.data.data.credit_balances))
      dispatch(setIsLoading(false))

      return true
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const postCreateTopUpSubmissions = createAsyncThunk(
  `${SLICE_NAME}/postCreateTopUpSubmissions`,
  async (
    {
      body,
    }: {
      body: AddAdsApprovalReqBodyInterface
      userId: number
    },
    { rejectWithValue, dispatch },
  ) => {
    dispatch(setIsLoading(true))
    try {
      const response = await postAdsSubmissionsAPI(body)

      dispatch(setIsLoading(false))

      toastSuccess('Pengajuan Top Up berhasil diajukan!')
      dispatch(
        push({
          url: AdsPrincipalDetailRoute.path.replace(':id', String(body.seller_id)),
        }),
      )

      return response
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
